import { render } from "./experience-cell.vue?vue&type=template&id=510da5b8&scoped=true"
import script from "./experience-cell.vue?vue&type=script&lang=js"
export * from "./experience-cell.vue?vue&type=script&lang=js"

import "./experience-cell.vue?vue&type=style&index=0&id=510da5b8&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-510da5b8"]])

export default __exports__